import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "px-9 w-96 h-96" };
const _hoisted_2 = { class: "flex justify-center" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("defs", null, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M32.955 24.148h-6.406a.658.658 0 00-.659.658 3.862 3.862 0 007.723 0 .658.658 0 00-.658-.658z",
        id: "a"
    })
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#FFF",
        d: "M1 0h256v256H1z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M38.188 163.488l18.834-40.22a3.942 3.942 0 012.886-2.211l87.76-15.475a37.18 37.18 0 0125.71 4.808l6.926 4.193a3.942 3.942 0 01.307 6.54l-33.044 24.509a49.281 49.281 0 01-21.03 8.99l-84.112 14.424a3.942 3.942 0 01-4.237-5.558z",
        fill: "#DDDBEA"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M39.379 168.899l18.514-37.835a3.942 3.942 0 012.856-2.15l84.952-14.978a49.281 49.281 0 0131.53 4.933l3.672 1.935-34.013 25.093a49.281 49.281 0 01-20.712 8.877L41.523 169.68l-2.144-.781z",
        fill: "#F7F7FF"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M37.83 164.008l19.19-40.748a3.942 3.942 0 012.882-2.202l87.767-15.476a37.18 37.18 0 0125.708 4.808l6.927 4.193a3.942 3.942 0 01.307 6.54l-33.143 24.582a49.281 49.281 0 01-20.8 8.95l-84.586 14.916a3.942 3.942 0 01-4.252-5.563z",
        stroke: "#FFF",
        "stroke-width": ".986"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M143.21 88.91l7.564-1.334a6.24 6.24 0 017.228 5.062l.808 4.579a1.59 1.59 0 001.842 1.29 2.046 2.046 0 001.685-1.862l.041-.555a2.762 2.762 0 012.275-2.513l1.018-.18a3.346 3.346 0 013.842 2.548l7.63 33.265a4.13 4.13 0 01-3.308 4.99l-24.404 4.303a4.13 4.13 0 01-4.845-3.96l-.797-30.95a5.3 5.3 0 01-6.14-4.3l-.344-1.95a7.28 7.28 0 015.905-8.433z",
        stroke: "#67D1E1",
        "stroke-width": ".5",
        fill: "#67D1E1"
    }),
    /*#__PURE__*/ _createElementVNode("g", {
        transform: "rotate(-10 675.928 -838.157)",
        fill: "#00292B"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M6.296 3.9a.403.403 0 01.561-.03c.164.144.177.39.03.55a3.602 3.602 0 01-2.663 1.17A3.6 3.6 0 011.56 4.421a.385.385 0 01.03-.55.403.403 0 01.562.03 2.797 2.797 0 002.073.909 2.8 2.8 0 002.072-.91z",
            "fill-rule": "nonzero"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "1.06",
            cy: ".52",
            r: "1"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "7.42",
            cy: ".52",
            r: "1"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M181.838 115.373a3.937 3.937 0 011.325 3.285c-.032.392-3.118 11.477-6.327 23.001l-.402 1.442c-3.347 12.024-6.695 24.06-6.73 24.518a3.934 3.934 0 01-1.373 2.702l-13.843 9.545a3.777 3.777 0 01-.764-2.222v-.052l-.001.062a3.795 3.795 0 01-7.588-.01v-.063l-.001.063a3.795 3.795 0 01-7.589 0v-.052.062a3.795 3.795 0 01-7.589-.01v-.063.063a3.795 3.795 0 01-7.59 0v-.052.062a3.795 3.795 0 01-7.588-.01v-.063l-.001.063a3.795 3.795 0 01-7.589 0v-.052.062a3.795 3.795 0 01-7.589-.01v-.063l-.001.063a3.795 3.795 0 01-7.588 0v-.052l-.001.062a3.795 3.795 0 01-7.589-.01v-.063.063a3.795 3.795 0 01-7.589 0v-.052l-.001.062a3.795 3.795 0 01-7.588-.01v-.063l-.001.063a3.795 3.795 0 01-7.588 0v-.052l-.002.062a3.795 3.795 0 01-7.588-.01v-.063.063a3.795 3.795 0 01-7.589 0v-.052l-.001.062a3.795 3.795 0 01-5.152 3.471c-2.691-6.646-5.107-12.74-5.271-13.67a3.942 3.942 0 01.201-2.095l.225-.078a3.942 3.942 0 004.606 4.289l84.585-14.915a49.281 49.281 0 0020.801-8.951l33.143-24.583a3.942 3.942 0 00.763-5.59l.464-.159z",
        fill: "#DDDBEA"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M143.68 105.577l.021.998-83.413 14.708a3.45 3.45 0 00-2.45 1.785l-.072.143-19.19 40.748a3.45 3.45 0 003.583 4.888l.137-.021 84.586-14.915a48.788 48.788 0 0020.176-8.556l.417-.305 33.143-24.583a3.45 3.45 0 00-.136-5.637l-.133-.085-6.927-4.193a36.71 36.71 0 00-.468-.279l-.29-1.285-.001-.014c.285.157.568.319.849.484l.42.25 6.927 4.194a4.435 4.435 0 01.516 7.224l-.17.132-33.143 24.583a49.774 49.774 0 01-20.49 8.946l-.52.094-84.585 14.915a4.435 4.435 0 01-4.862-6.078l.08-.18 19.19-40.747a4.435 4.435 0 013.072-2.445l.17-.033 83.563-14.736z",
        fill: "#FFF",
        "fill-rule": "nonzero"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M11.24 191.808a4.928 4.928 0 004.927-4.833l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 009.855.014l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 004.928 4.847M1 118.208a4.928 4.928 0 004.927-4.833l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 009.855.014l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 004.928 4.847M139.88 202.688a4.928 4.928 0 004.927-4.833l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 009.855.014l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 004.928 4.847M222.44 118.208a4.928 4.928 0 004.927-4.833l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 009.855.014l.001-.081v.066a4.928 4.928 0 009.855 0l.001-.08v.081a4.928 4.928 0 004.928 4.847",
        style: { "mix-blend-mode": "multiply" },
        stroke: "#DDDBEA",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.28"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M186.6 118.232c2.43 0 4.405-1.886 4.45-4.229l.001-.071v.06c.04 2.348 2.018 4.24 4.451 4.24 2.434 0 4.411-1.892 4.45-4.24l.002-.072v.071c.04 2.349 2.018 4.241 4.451 4.241 2.43 0 4.405-1.886 4.45-4.229l.001-.071.001.06c.04 2.348 2.017 4.24 4.45 4.24 2.434 0 4.412-1.892 4.451-4.24v-.072l.001.071c.04 2.349 2.017 4.241 4.45 4.241",
        style: { "mix-blend-mode": "multiply" },
        stroke: "#DDDBEA",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.16"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M132.428 134.172l-18.943-107.43",
        stroke: "#BBB7D5",
        "stroke-linecap": "round",
        "stroke-width": "2.464"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M84.551 111.192l1.036-.462a4.03 4.03 0 015.185 1.762 1.087 1.087 0 002.039-.441l.1-1.423a5.856 5.856 0 014.825-5.356 6.036 6.036 0 016.487 3.326l.67 1.394a1.056 1.056 0 002.002-.344 3.861 3.861 0 014.083-3.432l1.318.084a5.514 5.514 0 015.162 5.322l.463 14.2a16.327 16.327 0 01-31.834 5.613l-4.465-13.638a5.395 5.395 0 012.93-6.605z",
        fill: "#FFC4C7"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M101.323 117.97a1.327 1.327 0 001.077-1.538.443.443 0 00-.877.111l.005.043a.443.443 0 01-.862.195l-.01-.042a.443.443 0 00-.87.154 1.328 1.328 0 001.537 1.077zm6.973-1.23a1.327 1.327 0 001.076-1.537.443.443 0 00-.877.111l.006.042a.443.443 0 01-.862.196l-.01-.042a.443.443 0 00-.871.154 1.327 1.327 0 001.538 1.077zm-.696 3.268a.442.442 0 11.752.468 3.975 3.975 0 01-5.841 1.03.443.443 0 01.546-.696 3.09 3.09 0 004.544-.803z",
        fill: "#00292B",
        "fill-rule": "nonzero"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M64.865 107.888l13.982.464a8.259 8.259 0 017.776 6.41l6.86 29.93a4.13 4.13 0 01-3.307 4.989l-24.6 4.337a4.13 4.13 0 01-4.812-3.53l-4.362-33.272a8.259 8.259 0 018.463-9.328z",
        stroke: "#FF7645",
        "stroke-width": ".5",
        fill: "#FF7645"
    }),
    /*#__PURE__*/ _createElementVNode("g", {
        transform: "scale(-1 1) rotate(17 -493.857 -128.246)",
        stroke: "#9893C0",
        "stroke-width": "1.352"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M18.65 16.024c0 4.215-3.586 7.63-8.011 7.63-4.425 0-8.012-3.415-8.012-7.63",
            "stroke-linecap": "round"
        }),
        /*#__PURE__*/ _createElementVNode("path", { d: "M.577 17.609l2.277-2.434L5.13 17.61m11.12-.027l2.277-2.433 2.276 2.433" }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "10.639",
            cy: "2.671",
            r: "2.671"
        }),
        /*#__PURE__*/ _createElementVNode("path", { d: "M10.639 5.341v18.314M4.153 10.301h12.209" }),
        /*#__PURE__*/ _createElementVNode("path", {
            "stroke-linecap": "square",
            d: "M16.743 9.157v2.289M4.534 9.157v2.289"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("g", {
        "fill-rule": "nonzero",
        transform: "rotate(-105 86.613 67.661)"
    }, [
        /*#__PURE__*/ _createElementVNode("use", {
            fill: "#FF7645",
            "xlink:href": "#a"
        }),
        /*#__PURE__*/ _createElementVNode("use", {
            "fill-opacity": ".1",
            fill: "#FFF",
            "xlink:href": "#a"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("g", {
        transform: "scale(-1 1) rotate(10 -705.802 -354.433)",
        fill: "#00292B"
    }, [
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "1.015",
            cy: ".532",
            r: "1"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "7.105",
            cy: ".532",
            r: "1"
        }),
        /*#__PURE__*/ _createElementVNode("ellipse", {
            stroke: "#00292B",
            "stroke-width": ".774",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            cx: "4.06",
            cy: "4.785",
            rx: "1.015",
            ry: "1.595"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M213.531 156.876l.042.017 6.148 2.627c.271.116.488.33.607.6l5.825 13.267a.99.99 0 01.05.138l10.26 34.725c-.717 1.453-2.246 2.456-4.016 2.456-2.432 0-4.408-1.895-4.448-4.246v-.06.06c-.04 2.351-2.017 4.246-4.449 4.246s-4.409-1.895-4.448-4.246v-.06l-.001.072c-.046 2.346-2.02 4.234-4.448 4.234-.094 0-.182.01-.272.034a.868.868 0 00-.245-.034c-2.433 0-4.409-1.895-4.448-4.246l-.002-.06v.06c-.039 2.351-2.015 4.246-4.448 4.246-2.432 0-4.408-1.895-4.448-4.246v-.06l-.001.072c-.046 2.346-2.02 4.234-4.448 4.234-2.432 0-4.409-1.895-4.448-4.246v-.06l-.001.06c-.04 2.351-2.016 4.246-4.448 4.246a4.54 4.54 0 01-2.021-.47l14.751-34.857a1.16 1.16 0 011.069-.708h2.57a1.16 1.16 0 001.105-.807l3.68-11.53c.15-.47.586-.79 1.079-.79h.03c.48 0 .911-.296 1.083-.745l1.244-3.254a1.16 1.16 0 011.497-.669z",
            fill: "#F7F7FF"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M214.08 183.66a.58.58 0 11.665-.95.58.58 0 01-.666.95zm-4.95 10.488a.58.58 0 11.102-1.156.58.58 0 01-.102 1.156zm7.893-7.632a.58.58 0 11.665-.95.58.58 0 01-.665.95zm-4.274 5.193a.58.58 0 11.666-.95.58.58 0 01-.666.95zm6.474-.825a.58.58 0 11.666-.95.58.58 0 01-.666.95zm-13.813 11.471a.58.58 0 11.101-1.155.58.58 0 01-.1 1.155zm15.576-8.155a.58.58 0 11.666-.95.58.58 0 01-.666.95zm.638-14.865a.58.58 0 11.1-1.155.58.58 0 01-.1 1.155zm5.514 17.736a.58.58 0 11.666-.95.58.58 0 01-.666.95z",
            fill: "#FFF"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M197.602 206.68l4.8-23.73a1.16 1.16 0 011.138-.93h2.331a1.16 1.16 0 001.107-.813l3.632-11.54c.146-.464.576-.78 1.062-.78h.014a1.16 1.16 0 001.086-.75l1.65-4.377h0",
            stroke: "#FFF",
            "stroke-width": "1.16",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M229.924 133.173c.048.022.094.047.138.075l10.495 6.567c.187.116.34.279.445.472l6.72 12.308a4.953 4.953 0 01-2.465.651c-2.673 0-4.846-2.097-4.889-4.7l-.001-.066v.066c-.043 2.603-2.215 4.7-4.889 4.7-2.673 0-4.845-2.097-4.888-4.7l-.001-.066v.08c-.051 2.596-2.22 4.686-4.89 4.686-.105 0-.205.013-.297.038a.948.948 0 00-.27-.038c-2.674 0-4.846-2.097-4.89-4.7v-.066.066c-.044 2.603-2.216 4.7-4.89 4.7-.99 0-1.91-.287-2.68-.782l8.994-11.499a1.28 1.28 0 011.008-.491h1.621c.498 0 .95-.289 1.16-.74l2.768-5.941a1.28 1.28 0 011.7-.62z",
        fill: "#F7F7FF"
    }),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#BBB7D5",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            d: "M91.24 41.61l63.36-7.05M91.24 86.337l63.36-7.05"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M100.04 39.407h1.757c.974 0 1.763.79 1.763 1.763a1.573 1.573 0 001.751 1.563l35.218-4.008a1.975 1.975 0 001.751-1.962c0-.99.77-1.81 1.76-1.872l1.76-.11a3.94 3.94 0 014.132 3.274c1.675 9.894 2.645 18.497 2.908 25.809.207 5.76-.024 10.42-.694 13.976a5.342 5.342 0 01-4.586 4.31l-2.208.277a1.167 1.167 0 01-1.312-1.157 1.167 1.167 0 00-1.312-1.158l-39.616 4.96c-.75.093-1.312.73-1.312 1.485 0 .743-.578 1.359-1.32 1.405l-2.2.138a2.292 2.292 0 01-2.308-3.04c2.458-7.072 3.814-14.137 4.068-21.196.253-7.041-.59-14.088-2.528-21.14a2.622 2.622 0 012.528-3.317z",
            fill: "#E8F679"
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            stroke: "#00292B",
            "stroke-linecap": "round",
            "stroke-width": "1.32"
        }, [
            /*#__PURE__*/ _createElementVNode("path", { d: "M122.872 54.465v-.002a1.32 1.32 0 112.614-.367v.002h0m7.844-1.102v-.002a1.32 1.32 0 112.614-.368v.002h0" }),
            /*#__PURE__*/ _createElementVNode("path", {
                d: "M135.189 56.74a5.284 5.284 0 01-4.493 5.97 5.284 5.284 0 01-5.965-4.501l10.458-1.47z",
                fill: "#00292B",
                "stroke-linejoin": "round"
            })
        ])
    ])
], -1);
const _hoisted_6 = [
    _hoisted_4,
    _hoisted_5
];
const _hoisted_7 = { class: "-mt-12 text-2xl font-bold text-primary-800 dark:text-gray-300" };
const _hoisted_8 = { class: "flex justify-end gap-8 pb-5 pr-6" };
const _hoisted_9 = { class: "px-8 py-10" };
const _hoisted_10 = {
    key: 0,
    class: "flex flex-col items-center"
};
const _hoisted_11 = { class: "text-4xl font-bold leading-none text-center text-primary-900 dark:text-gray-300 max-w-180" };
const _hoisted_12 = {
    key: 1,
    class: "flex flex-col items-center"
};
const _hoisted_13 = { class: "text-4xl font-bold leading-none text-center text-primary-900 dark:text-gray-300 max-w-180" };
const _hoisted_14 = { class: "mt-6 text-sm" };
const _hoisted_15 = { class: "flex flex-col mt-6 space-y-4" };
const _hoisted_16 = {
    key: 2,
    class: "flex flex-col items-center"
};
const _hoisted_17 = { class: "text-4xl font-bold leading-none text-center text-primary-900 dark:text-gray-300 max-w-180" };
const _hoisted_18 = { class: "mt-6 text-sm text-center max-w-150" };
const _hoisted_19 = { class: "flex space-x-16" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.workspaces.change_plan')
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import ChooseTeamTable from '@/components/workspaces/ChooseTeamTable.vue';
import CommonFeatureCard from '@/components/workspaces/CommonFeatureCard.vue';
import ContractTermEnds from '@/components/pricing/ContractTermEnds.vue';
import Dialog from '@/components/Dialog.vue';
import Modal from '@/components/Modal.vue';
import NumberStepper from '@/components/progress/NumberStepper.vue';
import PricingToggleableOptions from '@/components/pricing/PricingToggleableOptions.vue';
import ProgressBar from '@/components/progress/ProgressBar.vue';
import Scaffold from '@/components/Scaffold.vue';
import WorkspaceSubheader from '@/components/workspaces/WorkspaceSubheader.vue';
import { useFullWidth } from '@/composables/useFullWidth';
import { useWorkspace } from '@/composables/workspaces';
import transitions from '@/helpers/transitions';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ChangePlan',
    setup(__props) {
        useFullWidth();
        const store = useStore();
        const router = useRouter();
        const { workspace } = useWorkspace();
        const selectedPlan = ref('pro');
        const selectedPaymentPeriod = ref('annual');
        const selectedTeam = ref(null);
        const currentStepIndex = ref(1);
        const isNextLoading = ref(false);
        const isModalVisible = ref(false);
        const teams = computed(() => workspace.value?.teams || []);
        const unarchivedTeams = computed(() => {
            return teams.value.filter((t) => !t.archivedAt);
        });
        const members = computed(() => workspace.value?.members || []);
        const sessionId = computed(() => store.getters.session.id);
        const isOwner = computed(() => {
            return !!members.value.find((m) => m.owner && m.id === sessionId.value);
        });
        const isLoaded = computed(() => !!workspace.value && isOwner.value);
        const isUnderFreeTeamsLimit = computed(() => unarchivedTeams.value.length <= 1);
        const stepNames = ['plan', 'features', 'team'];
        const currentStepName = computed(() => stepNames[currentStepIndex.value - 1]);
        const isFirstStep = computed(() => currentStepName.value === 'plan');
        const isSecondStep = computed(() => currentStepName.value === 'features');
        const isLastStep = computed(() => {
            const plan = selectedPlan.value;
            const unarchivedCount = unarchivedTeams.value.length;
            const step = currentStepName.value;
            return ((plan === 'free' && !isUnderFreeTeamsLimit.value && step === 'team') ||
                (plan === 'free' && isUnderFreeTeamsLimit.value && step === 'features') ||
                (plan !== 'free' && step === 'plan'));
        });
        const nextStepDisabledReason = computed(() => {
            if (currentStepName.value === 'plan' && workspace.value?.plan === selectedPlan.value) {
                return 'select_new_plan';
            }
            else if (currentStepName.value === 'team' &&
                !selectedTeam.value &&
                !isUnderFreeTeamsLimit.value) {
                return 'select_a_team';
            }
            return null;
        });
        const isNextDisabled = computed(() => !!nextStepDisabledReason.value);
        const nextButtonText = computed(() => {
            if (isLastStep.value) {
                return selectedPlan.value === 'free' ? 'downgrade' : 'upgrade';
            }
            else {
                return 'next';
            }
        });
        const hasToShowModal = computed(() => {
            // only show modal in the team step
            if (currentStepName.value !== 'team') {
                return false;
            }
            // don't show the modal if the workspace has just one or zero teams
            if (unarchivedTeams.value.length <= 1) {
                return false;
            }
            const inProgressRetros = unarchivedTeams.value.filter((t) => t.hasInProgressRetro);
            // show the modal if there are more than one team with a retro in progress
            if (inProgressRetros.length >= 2) {
                return true;
            }
            // show the modal if there's only one team with a retro in progress
            // and the user wants to keep another one
            if (inProgressRetros.length === 1 && inProgressRetros[0].id !== selectedTeam.value?.id) {
                return true;
            }
            return false;
        });
        watch(workspace, () => {
            if (workspace.value) {
                if (!isOwner.value) {
                    router.push({ name: 'showWorkspace' });
                    return;
                }
                if (!workspace.value.hasDecidedPricingPlan) {
                    currentStepIndex.value = 2;
                    handlePlanChoice('free');
                }
            }
        });
        function handlePlanChoice(plan) {
            selectedPlan.value = plan;
        }
        function handlePreviousButton() {
            currentStepIndex.value--;
        }
        function handleNextButton() {
            if (isLastStep.value) {
                if (selectedPlan.value === 'free') {
                    if (hasToShowModal.value) {
                        isModalVisible.value = true;
                    }
                    else {
                        downgrade();
                    }
                }
                else {
                    upgrade();
                }
            }
            else {
                currentStepIndex.value++;
            }
        }
        function handleConfirmModal() {
            isModalVisible.value = false;
            downgrade();
        }
        function handleCancelModal() {
            isModalVisible.value = false;
        }
        async function upgrade() {
            isNextLoading.value = true;
            try {
                await store.dispatch('changePlan', {
                    plan: selectedPlan.value,
                    paymentPeriod: selectedPaymentPeriod.value
                });
                store.dispatch('flashThenClear', { message: 'plan_changed' });
                router.push({ name: 'showWorkspace' });
            }
            catch (error) {
                store.dispatch('flashThenClear', { message: 'workspace_update_failure' });
            }
            isNextLoading.value = false;
        }
        async function downgrade() {
            isNextLoading.value = true;
            try {
                await store.dispatch('changePlan', { plan: 'free', selectedTeam: selectedTeam.value });
                store.dispatch('flashThenClear', { message: 'plan_changed' });
                router.push({ name: 'showWorkspace' });
            }
            catch (_) {
                store.dispatch('flashThenClear', { message: 'update_workspace_failure' });
            }
            isNextLoading.value = false;
        }
        const { scale } = transitions;
        const { scaleIn, scaleOut } = scale;
        return (_ctx, _cache) => {
            const _component_Paragraph = _resolveComponent("Paragraph");
            const _component_TextButton = _resolveComponent("TextButton");
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_TransitionA11y = _resolveComponent("TransitionA11y");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(isLoaded))
                    ? (_openBlock(), _createBlock(Scaffold, {
                        key: 0,
                        class: "h-screen pt-10"
                    }, {
                        subheader: _withCtx(() => [
                            _createVNode(WorkspaceSubheader)
                        ]),
                        content: _withCtx(() => [
                            _createVNode(Modal, { class: "z-50" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_TransitionA11y, {
                                        css: false,
                                        enter: _unref(scaleIn),
                                        leave: _unref(scaleOut),
                                        class: "px-2 my-2"
                                    }, {
                                        default: _withCtx(() => [
                                            (isModalVisible.value)
                                                ? (_openBlock(), _createBlock(Dialog, { key: 0 }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_1, [
                                                            _createElementVNode("div", _hoisted_2, [
                                                                (_openBlock(), _createElementBlock("svg", {
                                                                    width: "263",
                                                                    height: "256",
                                                                    viewBox: "0 0 263 256",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                                                    src: '@/assets/images/activities-sailboat.svg',
                                                                    "svg-inline": '',
                                                                    class: _normalizeClass('w-64 h-64')
                                                                }, _hoisted_6, 8, _hoisted_3))
                                                            ]),
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('retro_in_progress')), 1),
                                                                _createVNode(_component_Paragraph, { class: "text-xs" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.$t('retro_in_progress_warning')), 1)
                                                                    ], undefined, true),
                                                                    _: 1
                                                                })
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_8, [
                                                            _createVNode(_component_TextButton, { onClick: handleCancelModal }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                                                ], undefined, true),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_PillButton, { onClick: handleConfirmModal }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('downgrade_now')), 1)
                                                                ], undefined, true),
                                                                _: 1
                                                            })
                                                        ])
                                                    ], undefined, true),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ], undefined, true),
                                        _: 1
                                    }, 8, ["enter", "leave"])
                                ], undefined, true),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_9, [
                                (_unref(currentStepName) === 'plan')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('choose_plan_title')), 1),
                                        _createVNode(PricingToggleableOptions, {
                                            "payment-period": selectedPaymentPeriod.value,
                                            "onUpdate:payment-period": _cache[0] || (_cache[0] = ($event) => ((selectedPaymentPeriod).value = $event)),
                                            class: "mt-7",
                                            selected: selectedPlan.value,
                                            onChoice: handlePlanChoice
                                        }, null, 8, ["payment-period", "selected"])
                                    ]))
                                    : (_unref(currentStepName) === 'features')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t('features_title')), 1),
                                            (_unref(workspace).hasDecidedPricingPlan)
                                                ? (_openBlock(), _createBlock(ContractTermEnds, {
                                                    key: 0,
                                                    date: _unref(workspace).subscriptionPeriodEnd
                                                }, null, 8, ["date"]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('features_subtitle')), 1),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createVNode(CommonFeatureCard, { feature: "unlimited_teams" }),
                                                _createVNode(CommonFeatureCard, { feature: "more_activities" }),
                                                _createVNode(CommonFeatureCard, { feature: "ice_breakers" })
                                            ])
                                        ]))
                                        : (_unref(currentStepName) === 'team')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t('choose_team_title')), 1),
                                                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('choose_team_subtitle')), 1),
                                                _createVNode(ChooseTeamTable, {
                                                    "selected-team": selectedTeam.value,
                                                    "onUpdate:selected-team": _cache[1] || (_cache[1] = ($event) => ((selectedTeam).value = $event)),
                                                    class: "w-full mt-16 max-w-150",
                                                    teams: _unref(unarchivedTeams)
                                                }, null, 8, ["selected-team", "teams"])
                                            ]))
                                            : _createCommentVNode("", true)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createVNode(ProgressBar, null, {
                                left: _withCtx(() => [
                                    _createVNode(NumberStepper, {
                                        "current-step": currentStepIndex.value,
                                        steps: [
                                            { number: 1, title: _ctx.$t('step_1') },
                                            ...(selectedPlan.value === 'free' ? [{ number: 2, title: _ctx.$t('step_2') }] : []),
                                            ...(selectedPlan.value === 'free' && !_unref(isUnderFreeTeamsLimit)
                                                ? [{ number: 3, title: _ctx.$t('step_3') }]
                                                : [])
                                        ]
                                    }, null, 8, ["current-step", "steps"])
                                ]),
                                right: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_19, [
                                        ((!_unref(isFirstStep) && !_unref(isSecondStep)) ||
                                            (_unref(isSecondStep) && _unref(workspace).hasDecidedPricingPlan))
                                            ? (_openBlock(), _createBlock(_component_TextButton, {
                                                key: 0,
                                                inverted: "",
                                                onClick: handlePreviousButton
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('previous')), 1)
                                                ], undefined, true),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        _withDirectives((_openBlock(), _createBlock(_component_PillButton, {
                                            kind: "secondary",
                                            loading: isNextLoading.value,
                                            disabled: _unref(isNextDisabled),
                                            onClick: handleNextButton
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(_unref(nextButtonText))), 1)
                                            ], undefined, true),
                                            _: 1
                                        }, 8, ["loading", "disabled"])), [
                                            [_directive_tooltip, _unref(isNextDisabled) && _ctx.$t(_unref(nextStepDisabledReason))]
                                        ])
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
